<ejs-dialog #modal [isModal]='true' 
    [header]="'Inativar Doença'" 
    [target]="'body'"
    [visible]="false"
    width="800px"
    height="640px"
    class="custom-dialog"
    (open)="modalOk=true"
    (close)="modalOk=false"
    [ngClass]="{ 'em-operacao': emOperacao }"
    [showCloseIcon]='true' id="inativar-doenca-modal"
    (beforeClose)="fechandoModal($event)"
    [closeOnEscape]='true'>

    <ng-template #content>
        <ejs-tab  #tab class='e-fill'>
            <div class="e-tab-header">
                <div>Informações Gerais</div>
            </div>
            <div class="e-content">
                <div class="" style="padding: 15px">
                    <form [formGroup]='modelo' [ngClass]="{'submitted': submetido}">
                        <div class='row' style="width: 100%">
                            <div class='col-xs-12 form-group' required>
                                <ax-select [placeholder]="'CID10'" [dataSource]="dsCids10"
                                appendTo='#inativar-doenca-modal'
                                [enabled]="false"
                                [formControlName]="'cid10Codigo'" [label]="'CID10'"></ax-select>
                                <app-error-handler [control]="modelo.get('cid10Codigo')" [submitted]='submetido'
                                [errorType]="'required'">
                                </app-error-handler>
                            </div>
                            <div class='col-xs-12 form-group'>
                                <ejs-datepicker formControlName="dataAtendimento" [placeholder]="'Data Atendimento/Diagnóstico de Cura'" 
                                [enabled]="false"
                                [floatLabelType]="'Always'"></ejs-datepicker>    
                            </div>
                        </div>

                        <div class='row' style="width: 100%">
                            <div class='col-xs-12 form-group' *ngIf="modalOk">
                                <app-texto-editor height="250px"
                                [label]="'Descrição sobre a inativação da doença...'"
                                [textoResete]='ultimaDescricao' [formControlName]="'descricao'"></app-texto-editor>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </ejs-tab>
    
    
    </ng-template>
    
    <ng-template #footerTemplate>
        <button  ejs-button  class=" e-btn e-primary" data-ripple="true" appDebounceClick
        [iconCss]="'fas fa-save'"
        (click)='inativar()'>Inativar</button>
        <button ejs-button  class="e-btn " data-ripple="true" (click)='cancelar()'>Cancelar</button>
    </ng-template>

</ejs-dialog>


